import React, { useRef } from "react";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";
import { scaleLinear } from "d3-scale";
const officialImg = require("./../../img/official.jpg").default;
const generatedImg = require("./../../img/generated.jpg").default;

const margin = {
  top: 10,
  right: 50,
  bottom: 10,
  left: 50,
};

const IMG_WIDTH = 2480 / 10;
const IMG_HEIGHT = 3507 / 10;

const LEFT_RATIO = 1;
const RIGHT_RATIO = 3;
const MAX_RIGHT_RATIO = 8;

const SideBySideMap = ({ data, title, note, source, progress = 0 }) => {
  const { ref, width } = useVizualisation(data);

  const height = 400;

  const rightImage = useRef(null);

  // const w = width - margin.left - margin.right
  // const h = height - margin.top - margin.bottom

  const offsetX = 0;

  const leftX = scaleLinear()
    .domain([0, IMG_WIDTH * LEFT_RATIO])
    .range([3459378.673, 4147149.893]);
  const leftY = scaleLinear()
    .domain([IMG_HEIGHT * LEFT_RATIO, 0])
    .range([-1988830.532, -1025036.258]);

  const rightX = scaleLinear()
    .domain([
      0,
      IMG_WIDTH * (RIGHT_RATIO + progress * (MAX_RIGHT_RATIO - RIGHT_RATIO)),
    ])
    .range([3711060.8, 3766410.4]);
  const rightY = scaleLinear()
    .domain([
      IMG_HEIGHT * (RIGHT_RATIO + progress * (MAX_RIGHT_RATIO - RIGHT_RATIO)),
      0,
    ])
    .range([-1585038.1, -1479851.9]);

  return (
    <Vizualisation
      title={title}
      note={note}
      source={source}
      ref={ref}
      size="large"
    >
      <svg viewBox="0 0 940 400">
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          <g className="left" transform={`translate(${0}, ${0})`}>
            <image
              width={IMG_WIDTH * LEFT_RATIO}
              height={IMG_HEIGHT * LEFT_RATIO}
              href={officialImg}
            />
            {/* <rect
              x={leftX.invert(rightX.range()[0])}
              y={leftY.invert(rightY.range()[1])}
              width={
                leftX.invert(rightX.range()[1]) -
                leftX.invert(rightX.range()[0])
              }
              height={
                leftY.invert(rightY.range()[0]) -
                leftY.invert(rightY.range()[1])
              }
              stroke='white'
              fill='none'
              style={{ strokeWidth: 1 }}
            /> */}
            <rect
              x={leftX.invert(rightX(0))}
              y={
                leftY.invert(
                  rightY(
                    progress *
                      (IMG_HEIGHT *
                        (RIGHT_RATIO +
                          progress * (MAX_RIGHT_RATIO - RIGHT_RATIO)))
                  )
                ) -
                progress * 5 // TODO: this value is not calculated, but just manually tweaked
              }
              width={leftX.invert(rightX(600)) - leftX.invert(rightX(0))}
              height={leftY.invert(rightY(350)) - leftY.invert(rightY(0))}
              fill="red"
              stroke="black"
              style={{ fillOpacity: 0.5 }}
            />
          </g>
          <g className="right" transform={`translate(${IMG_WIDTH + 50}, 0)`}>
            <clipPath id="zoom-view">
              <rect width={600} height={350} />
            </clipPath>
            <g clipPath="url(#zoom-view)">
              <image
                transform={`translate(${offsetX}, ${
                  -progress * rightY.domain()[0] + progress * 350
                })`}
                width={rightX.domain()[1]}
                height={rightY.domain()[0]}
                href={generatedImg}
                ref={rightImage}
              />
            </g>
          </g>
        </g>
      </svg>
      {/* <button
        onClick={() => {
          setOffsetX(offsetX + 10)
        }}
      >
        right
      </button>
      <button
        onClick={() => {
          setOffsetX(offsetX - 10)
        }}
      >
        left
      </button> */}
    </Vizualisation>
  );
};

export default SideBySideMap;
